export default "__VITE_ASSET__CBWmlg5s__"